import { config } from '@abyss/web/tools/config';

import { useCustomQuery } from '../useCustomQuery';
import GetLocation from './Location.graphql';

export const useLocation = (options) =>
  useCustomQuery(GetLocation, {
    url: config('GRAPHQL_API_URL'),
    accessor: 'location',
    ...options,
  });
